import Tween from '../lib/Tween'

export default {
	methods: {
		addTween(options, stepCallback, doneCallback) {
			// Create tween promise, add to set, then return it
			const opts = { fps: this.$fps, ...options }
			const inst = new Tween(opts, stepCallback, doneCallback)
			this._tweens.add(inst)
			return inst
		},
		removeTween(inst, finished = false) {
			if (inst) {
				// Run done callback if it exists, then delete the tween
				if (inst.doneCallback && !finished) inst.doneCallback(false)
				this._tweens.delete(inst)
			}
		},
		removeAllTweens() {
			this._tweens.clear()
		}
	},
	created() {
		// Set up tweens map
		this._tweens = new Set()

		// Set up bound tick function if component defined it
		if (this.$options.tick && typeof this.$options.tick === 'function') {
			this._componentTick = this.$options.tick.bind(this)
		}

		// Create callback to be consumed by Animator class
		this._animatorCallback = () => {
			// Run component tick if it exists
			if (this._componentTick) this._componentTick()

			// Run tweens
			if (this._tweens.size > 0) {
				for (const inst of this._tweens) {
					const done = inst.next()
					if (done) this.removeTween(inst, true)
				}
			}
		}

		// Register callback
		this.$animator.register(this._animatorCallback)
	},
	beforeDestroy() {
		// Remove animator callback
		this.$animator.deregister(this._animatorCallback)
	}
}
